import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Layout/Navbar";
import { ShieldX } from "lucide-react";

// Pages
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import MoviesPage from "./pages/MoviesPage";
import SeriesPage from "./pages/SeriesPage";
import LiveTVPage from "./pages/LiveTVPage";
import MovieDetailPage from "./pages/MovieDetailPage";
import SeriesDetailPage from "./pages/SeriesDetailPage";
import LivePlayerPage from "./pages/LivePlayerPage";
import SearchPage from "./pages/SearchPage";
import MyListPage from "./pages/MyListPage";
import AdminPanel from "./pages/AdminPanel";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NoLicenseBanner = () => (
  <div className="fixed top-0 left-0 right-0 z-[100] bg-red-600/90 backdrop-blur-sm px-4 py-2 flex items-center justify-center gap-2 text-white text-sm">
    <ShieldX className="w-4 h-4" />
    <span>No valid license. Only admin login is available.</span>
  </div>
);

function App() {
  const [licenseValid, setLicenseValid] = useState(null);

  const checkLicense = () => {
    fetch(`${BACKEND_URL}/api/license/status`)
      .then(r => r.json())
      .then(d => setLicenseValid(d.licensed === true))
      .catch(() => setLicenseValid(false));
  };

  useEffect(() => { checkLicense(); }, []);

  if (licenseValid === null) {
    return <div className="min-h-screen bg-[#0a0a0b]" />;
  }

  return (
    <SettingsProvider>
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          {!licenseValid && <NoLicenseBanner />}
          <Routes>
            {/* Login + Admin always accessible */}
            <Route path="/login" element={<LoginPage licenseValid={licenseValid} />} />
            <Route path="/admin" element={<AdminPanel onLicenseChange={checkLicense} />} />

            {/* Protected routes - only when licensed */}
            {licenseValid ? (
              <Route path="/*" element={
                <ProtectedRoute>
                  <>
                    <Navbar />
                    <main className="min-h-screen">
                      <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/movies" element={<MoviesPage />} />
                        <Route path="/series" element={<SeriesPage />} />
                        <Route path="/live" element={<LiveTVPage />} />
                        <Route path="/movie/:id" element={<MovieDetailPage />} />
                        <Route path="/series/:id" element={<SeriesDetailPage />} />
                        <Route path="/live/:id" element={<LivePlayerPage />} />
                        <Route path="/my-list" element={<MyListPage />} />
                        <Route path="/search" element={<SearchPage />} />
                      </Routes>
                    </main>
                  </>
                </ProtectedRoute>
              } />
            ) : (
              <Route path="*" element={<LoginPage licenseValid={licenseValid} />} />
            )}
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
    </SettingsProvider>
  );
}

export default App;
